module.exports = __webpack_public_path__ + "static/media/blueWave.37053246.jpg";